import Script from 'next/script';

const gtm = process.env.NODE_ENV === 'production' && 'GTM-5GQGGPJ';

const Scripts = (): JSX.Element => (
  <>
    {gtm && (
      <Script id="gtm-init" strategy="beforeInteractive">
        {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(
            { 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true; j.src =
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window, document, 'script', 'dataLayer', '${gtm}');`}
      </Script>
    )}
  </>
);

export default Scripts;
